import * as React from "react";
function SvgCornersTag(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M25.4 14.1l7.9 6.4-11.7 14.4-6.8-.1-1.3-6.2 11.9-14.5m-.4-3.9L10.7 28l2 9.7 10.3.1 14.3-17.6c0-.2-12.3-10-12.3-10zm-6.4 18c-1.4 0-2.4 1.1-2.4 2.5s1.1 2.4 2.5 2.4c1.3 0 2.4-1.1 2.4-2.4.1-1.3-1.1-2.5-2.5-2.5.2 0 0 0 0 0zM1.4 14.1c-.8 0-1.4-.6-1.4-1.4V1.4C0 .6.6 0 1.4 0h11.3c.8 0 1.4.6 1.4 1.4s-.6 1.4-1.4 1.4H2.8v9.9c0 .9-.5 1.4-1.4 1.4zM12.7 48H1.4C.6 48 0 47.4 0 46.6V35.3c0-.8.6-1.4 1.4-1.4s1.4.6 1.4 1.4v9.9h9.9c.8 0 1.4.6 1.4 1.4 0 .8-.5 1.4-1.4 1.4zm33.9-33.9c-.8 0-1.4-.6-1.4-1.4V2.8h-9.9c-.8 0-1.4-.6-1.4-1.4S34.4 0 35.3 0h11.3c.8 0 1.4.6 1.4 1.4v11.3c0 .9-.6 1.4-1.4 1.4zm0 33.9H35.3c-.8 0-1.4-.6-1.4-1.4 0-.8.6-1.4 1.4-1.4h9.9v-9.9c0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4v11.3c0 .8-.6 1.4-1.4 1.4z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCornersTag);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
